export class LoadLarsExportLinks {
    static readonly type = '[LARS Export] Load Export Links';

    constructor(
        public payload: {
            accountingUnitIds: string[];
            period: string;
        }
    ) {}
}

export class ClearLarsExportLinks {
    static readonly type = '[LARS Export] Clear Export Links';
}
